// const aiImage = "/public/img/AI-productivity-dashboard.png";
// const localImage = "/public/img/Local-services.png";
// const commerceImage = "/public/img/ecormmerce-website.png"

const Projects = () => {
     const projects = [
    {
      title: 'StoryPlugs Website',
      description: 'A responsive storytelling web app for publishing and managing creative content.',
      tech: ['React', 'Firebase', 'Vercel', "Cloudinary"], 
      link: 'https://storyplugs.vercel.app/',
      image: "../img/storyplugs-project-image.png",
    },
    {
      title: 'AI Productivity Dashboard',
      description: 'A React + Firebase dashboard with AI tools and task manager.',
      tech: ['React', 'Firebase', 'OpenAI', "Cloudinary"],
      link: 'https://tasks-productivity-dashboard.netlify.app/',
      image: "../img/AI-productivity-dashboard.png",
    },
    {
      title: 'Local Services Marketplace',
      description: 'A full-stack app to connect service providers and clients.',
      tech: ['React', 'Node.js', 'MongoDB'],
      link: 'https://service-9ja.netlify.app/',
      image: "../img/Local-services.png",
    },
    {
      title: 'E-commerce App',
      description: 'A fully functional shop app with cart, filter, and payment.',
      tech: ['React', 'Firebase', 'Paystack'],
      link: 'https://shop-smart-4aef1.web.app/',
      image: "../img/ecormmerce-website.png",
    },
  ];

    return(
        <div className="personalPage">   
            
            

            <section className="projects">
                <h2>My Projects</h2>
                <div className="project-grid">
                    {projects.map((project, index) => (
                        <div className="project-card" key={index}>
                            <h3>{project.title}</h3> 
                            <p>{project.description}</p> 
                            <img src={project.image} alt="project-image"/> 
                                <div className="tech-list">
                                    {project.tech.map((t, i) => (
                                        <span key={i}>{t}</span>
                                    ))}
                                </div>
                            <a href={project.link} target="_blank" rel="noopener noreferrer">View Project</a>
                        </div>
                    ))}
                </div>
    </section>

        </div>
    );
        
};

export default Projects;